import { render, staticRenderFns } from "./OpenPacsViewer.vue?vue&type=template&id=4afdebbd&"
import script from "./OpenPacsViewer.vue?vue&type=script&lang=js&"
export * from "./OpenPacsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports